module.exports = __webpack_public_path__ + "../../../static/img/c_im_20.9412538c.png";